<template>
	<div class="relative !px-4 !py-16 flex flex-col gap-4 items-center !container mx-auto !max-w-seint">
		<button
			type="button"
			aria-label="Go Back"
			@click="handleBackStep"
			class="inline-flex items-center absolute left-4 top-5 gap-2 text-[11px]/[14px] uppercase font-medium"
		>
			<svg-vue icon="back-arrow" />
			<span>Back</span>
		</button>
		<div>
			<h1 class="!m-0 !p-0 font-butler-light text-3xl/[38px] font-light text-center">Select your age range</h1>
			<p class="!m-0 !p-0 text-sm text-center">(This helps us understand your skin needs)</p>
		</div>
		<ul class="flex flex-col w-full max-w-[400px] mx-auto gap-3 !m-0 !p-0">
			<li v-for="option in options" :key="option">
				<button
					type="button"
					aria-label=""
					@click="() => handleNextStep(option)"
					:class="[
						'flex flex-col items-center justify-center',
						'w-full !p-3',
						'seint-border hover:ring-2 hover:ring-light-gray-900 hover:dark:ring-white',
						ageRange === option ? 'ring-2 ring-black' : 'border-brand-solid',
					]"
				>
					<span class="text-sm">{{ option }}</span>
				</button>
			</li>
		</ul>
	</div>
</template>
<script setup>
import { ref, onMounted } from 'vue'

const props = defineProps({
	ageRange: {
		type: String,
		default: null,
	},
	setAgeRange: {
		type: Function,
		required: true,
	},
	setStep: {
		type: Function,
		required: true,
	},
})

const options = ref(['Under 21', '21 - 34', '35 - 40', '41 - 50', '51 - 65', '65+'])

onMounted(() => {
	window.scrollTo(0, 0)
})

const handleBackStep = () => props.setStep(4)
const handleNextStep = (selection) => {
	props.setAgeRange(selection)
	props.setStep(6)
}
</script>
